import React, { useState, useEffect } from 'react';
import { getPicks, getCurrentRace, getRaces, isRaceLocked } from '../../api';
import Picks from './Picks';

export default function CurrentWeekPage() {
    const [currentUser, setCurrentUser] = useState(null);
    const [raceId, setRaceId] = useState('');
    const [raceName, setRaceName] = useState('');
    const [positions, setPositions] = useState(Array(7).fill(''));
    const [dnf, setDnf] = useState('No DNF');
    const [message, setMessage] = useState('');
    const [locked, setLocked] = useState(false);

    useEffect(() => {
        const raw = localStorage.getItem('currentUser');
        if (raw) {
            try { setCurrentUser(JSON.parse(raw)); } catch (e) { setCurrentUser(null); }
        }
        getCurrentRace().then((id) => {
            if (id) setRaceId(id);
        });
        getRaces().then((rs) => {
            // set name if current race exists
            getCurrentRace().then((id) => {
                const found = rs.find((r) => String(r.id) === String(id));
                if (found) setRaceName(found.name);
            });
        });
    }, []);

    useEffect(() => {
        if (!currentUser || !raceId) return;
        getPicks(raceId, currentUser.id).then((all) => {
            const me = all.find((p) => p.username == currentUser.id);
            if (me) {
                // ensure positions length matches
                setPositions((prev) => me.picks.slice(3, 10).concat(Array(Math.max(0, prev.length - (me.picks.slice(3, 10).length))).fill('')));
                setDnf(me.dnf || 'No DNF');
            }
        });
        isRaceLocked(raceId).then(setLocked);
    }, [raceId, currentUser]);

    function updatePos(index, value) {
        const next = [...positions];
        next[index] = value;
        setPositions(next);
    }

    // no auto-submit here; `Picks` component handles saving on button click

    return (
        <div className="picks-page">
            <h2>{raceName}</h2>
            <Picks />
        </div>
    );
}
